// extracted by mini-css-extract-plugin
export default {"overlay":"WidgetOverlay_overlay__C+lE3","show":"WidgetOverlay_show__l7-Kd"};